import { ScissorState, ScissorStateParams } from '../../states/ScissorState'

export class ScissorStateGPU extends ScissorState {

  public commitChanges(changes: ScissorStateParams) {
    //
  }
}
